export const monthsForDropdown = [
  { label: "Jan", value: "Jan" },
  { label: "Feb", value: "Feb" },
  { label: "Mar", value: "Mar" },
  { label: "Apr", value: "Apr" },
  { label: "May", value: "May" },
  { label: "Jun", value: "Jun" },
  { label: "Jul", value: "Jul" },
  { label: "Aug", value: "Aug" },
  { label: "Sep", value: "Sep" },
  { label: "Oct", value: "Oct" },
  { label: "Nov", value: "Nov" },
  { label: "Dec", value: "Dec" },
];

export const years = [2024, 2025, 2026];

export type Month = {
  name: string;
  columns: Array<"Renewal" | "Allocation" | "Usage">;
};

export type TableRow = {
  label: string;
  users?: number | string;
  paidUsers?: number | string;
  unpaidUsers?: number | string;
  monthData: Array<{
    AutoTopup: number | string;
    AutoTopupFailed: number | string;
  }>;
  bold?: boolean;
  isSummary?: boolean;
  bg?: string;
};
